import React, { Component } from 'react';
// import Logo from '../../assets/images/favicon.png'
import HeaderLinksData from '../../models/headerlinks';
import LegalLinksData from '../../models/legalinks';

class Header extends Component {
  render() {
    let headerlinksdata = HeaderLinksData;
    let legallinksdata = LegalLinksData;
      return (
      <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary bg-dark border-bottom border-body pb-nav-header" data-bs-theme="dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            {/* <img src={Logo} alt="Logo" width="25" height="25" className="d-inline-block align-text-top logo-pos" /> */}
            <span className="pb-brand-header">Pix Byte ™</span>
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasDarkNavbar" aria-controls="offcanvasDarkNavbar" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="offcanvas offcanvas-end text-bg-dark pb-header-canvas" tabIndex="-1" id="offcanvasDarkNavbar" aria-labelledby="offcanvasDarkNavbarLabel">
            <div className="offcanvas-header pb-nav-canvas-header">
              <h5 className="offcanvas-title" id="offcanvasDarkNavbarLabel">Copyright © Pix Byte ™</h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                {
                  headerlinksdata.map((item, index) => {
                    return <li className="nav-item" key={index}><a className="nav-link pb-header-link" href={item.route}>{item.title}</a></li>
                  })
                }
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle pb-header-menu-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Legal
                  </a>
                  <ul className="dropdown-menu pb-header-menu">
                    {
                      legallinksdata.map((item, index) => {
                        return <li key={index}><a className="dropdown-item pb-header-menu-item" href={item.route}>{item.title}</a></li>
                      })
                    }
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Header;
